import React, { useRef } from 'react';
import ComponentIdentifier from '../../CommonComponent/ComponentHeader/ComponentIdentifier';
import { Button, Card } from 'react-bootstrap';
import SoftBill from './SoftBill';
import TaqwaBill from '../../../assets/images/TaqwaBill.jpg'
import BibiBill from '../../../assets/images/bibi-bill.jpg'
import EnglishMediumSchoolBill from '../../../assets/images/ems-bill.jpg'
import Signater from '../../../assets/images/sig-01.jpg';
import { useSearchParams } from 'react-router-dom';
import * as converter from "number-to-words"
import * as htmlToImage from 'html-to-image';


export const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
    });
};




function SoftCopyPrintComponent({ printDetails, printDataAgent }) {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const promise_token = searchParams.get("promise_token")
    const softBillRef = useRef()


    // const downloadImage = async () => {
    //     const node = softBillRef.current;
    //     if (!node) return;

    //     await document.fonts.ready; // wait for fonts

    //     // Clone the node to avoid layout issues
    //     const clone = node.cloneNode(true);

    //     // Create a temporary off-screen div
    //     const tempDiv = document.createElement("div");
    //     tempDiv.style.position = "absolute";
    //     tempDiv.style.top = "-9999px";
    //     tempDiv.style.left = "-9999px";
    //     tempDiv.style.width = "800px"; // full width
    //     tempDiv.style.height = "420px"; // full height
    //     tempDiv.style.background = "white"; // ensures white background
    //     tempDiv.appendChild(clone);
    //     document.body.appendChild(tempDiv);


    //     htmlToImage
    //         .toPng(clone, {
    //             width: node.scrollWidth,
    //             height: node.scrollHeight,
    //             cacheBust: true,
    //             useCors: true,
    //         })
    //         .then((dataUrl) => {
    //             const link = document.createElement("a");
    //             link.download = "voucher.png";
    //             link.href = dataUrl;
    //             link.click();

    //             // remove temporary div
    //             document.body.removeChild(tempDiv);
    //         })
    //         .catch((err) => {
    //             console.error("Error converting to PNG:", err);
    //             document.body.removeChild(tempDiv);
    //         });
    // };

    // const downloadImage = async () => {
    //     const node = softBillRef.current;
    //     if (!node) return;

    //     await document.fonts.ready; // wait for fonts

    //     // Clone the node
    //     const clone = node.cloneNode(true);

    //     // Off-screen container (your positioning preserved)
    //     const tempDiv = document.createElement("div");
    //     // tempDiv.style.position = "absolute";
    //     // tempDiv.style.top = "-9999px";
    //     // tempDiv.style.left = "-9999px";
    //     tempDiv.style.background = "white";
    //     tempDiv.style.padding = "0";
    //     tempDiv.style.margin = "0";

    //     tempDiv.appendChild(clone);
    //     document.body.appendChild(tempDiv);

    //     // IMPORTANT: force browser layout
    //     await new Promise(requestAnimationFrame);

    //     // Measure AFTER layout
    //     const width = clone.offsetWidth;
    //     const height = clone.offsetHeight;

    //     htmlToImage
    //         .toPng(tempDiv, {
    //             width,
    //             height,
    //             cacheBust: true,
    //             pixelRatio: 2,
    //             backgroundColor: "#ffffff",
    //             useCors: true,
    //         })
    //         .then((dataUrl) => {
    //             const link = document.createElement("a");
    //             link.download = "voucher.png";
    //             link.href = dataUrl;
    //             link.click();
    //         })
    //         .catch((err) => {
    //             console.error("Error converting to PNG:", err);
    //         })
    //         .finally(() => {
    //             document.body.removeChild(tempDiv);
    //         });
    // };
    const downloadImage = async () => {
        const node = softBillRef.current;
        if (!node) return;

        await document.fonts.ready;

        const clone = node.cloneNode(true);

        const tempDiv = document.createElement("div");
        tempDiv.style.background = "white";
        tempDiv.style.padding = "0";
        tempDiv.style.margin = "0";
        tempDiv.style.fontFamily = "Arial, sans-serif"; // 🔥 important
        tempDiv.style.width = "800px"; // full width
        tempDiv.style.height = "419px"; // full height

        tempDiv.appendChild(clone);
        document.body.appendChild(tempDiv);

        await new Promise(requestAnimationFrame);

        const width = tempDiv.offsetWidth;
        const height = tempDiv.offsetHeight;

        try {
            const dataUrl = await htmlToImage.toPng(tempDiv, {
                width,
                height,
                pixelRatio: 2,
                backgroundColor: "#ffffff",
                cacheBust: true,
                useCors: true,
                skipFonts: true, // 🔥 prevents crash
            });

            const link = document.createElement("a");
            link.download = `${printDetails?.member?.member_name || "voucher"}.png`;
            link.href = dataUrl;
            link.click();
        } catch (err) {
            console.error("Error converting to PNG:", err);
        } finally {
            document.body.removeChild(tempDiv);
        }
    };

    return (
        <>

            <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                    <ComponentIdentifier link_name={"Soft copy"} component_name={""} />
                </Card.Header>
                <Card.Body>
                    <div ref={softBillRef} className='imageBill' style={{
                        backgroundImage: `url(${printDetails?.cnfg_organization?.id == 5 ? TaqwaBill : printDetails?.cnfg_organization?.id == 4 ? BibiBill : printDetails?.cnfg_organization?.id == 6 ? EnglishMediumSchoolBill : ""})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}>
                        <div className='billId'><strong>Bill No.: </strong>{printDetails.id}</div>
                        <div className='billType'>{promise_token ? "PROMISED BILL" : "DONATION BILL"}</div>
                        <div className='billDate'><strong>Date: </strong>{formatDate(printDetails.createdAt)}</div>
                        <div className='billDonerName'><strong>Doner's Name: </strong>{printDetails?.member?.member_name}</div>
                        <div className='billDonerAddress'><strong>Address: </strong>{`${printDetails?.member?.village ? printDetails?.member?.village : ""}${printDetails?.member?.village ? "," : ""} ${printDetails?.member?.police_station ? printDetails?.member?.police_station : ""}${printDetails?.member?.police_station ? "," : ""} ${printDetails?.member?.district ? printDetails?.member?.district : ""}${printDetails?.member?.district ? "," : ""} ${printDetails?.member?.state ? printDetails?.member?.state : ""} `}</div>
                        <div className='billAmount1'><strong>Amount in words: </strong>{printDetails?.collection_amount && converter.toWords(printDetails.collection_amount).replace(/\b\w/g, (char) => char.toUpperCase())} Only <br /> {printDetails.purpose === "Other" && (
                            <>
                                <strong>Goods: </strong>{printDetails.goods},
                                <span>({printDetails.quantity})</span>
                            </>
                        )}
                            <div className='billParpus'> {printDetails.purpose ? <><strong>Purpose: </strong>{printDetails.purpose}</> : ""} {printDetails.paymeny_type ? <>, <strong>Payment Type: </strong>{printDetails.paymeny_type}</> : ""} </div></div>
                        <div className='billAmount2'> ₹ {printDetails.collection_amount} /-</div>

                        <div className='billPhone'> <strong>Mobile Number: </strong>{printDetails?.member?.mobile} </div>

                        <div className='calect'> {printDataAgent.full_name} </div>
                    </div>


                    <div className="mt-3">
                        <Button onClick={downloadImage}>Download as Image</Button>
                        <Button
                            className="ms-2 btn-success"
                            onClick={() => window.open(`https://wa.me/${printDetails?.member?.whats_app}`, "_blank")}
                        >
                            Send WhatsApp
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

export default SoftCopyPrintComponent;